import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SemanticSearchRequest {
  query_text: string;
  top_k?: number;
  prefer_recent?: boolean;
}

export interface SemanticSearchResult {
  note_id?: string;
  id?: string;
  title?: string;
  snippet?: string;
  semantic_score?: number;
  status_boost?: number;
  recency_boost?: number;
  final_score?: number;
  matched_tags?: string[];
  matched_keywords?: string[];
  matched_ai_keywords?: string[];
  matched_terms?: string[];
  distance?: number;
  score?: number;
  [key: string]: unknown;
}

export interface SemanticSearchData {
  results?: SemanticSearchResult[];
  [key: string]: unknown;
}

export interface SemanticSearchResponse {
  status?: string;
  data?: SemanticSearchData;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class SemanticSearchService {
  constructor(private readonly http: HttpClient) {}

  searchNotes(payload: SemanticSearchRequest): Observable<SemanticSearchResponse> {
    return this.http.post<SemanticSearchResponse>('/api/ai/search-notes', payload);
  }
}
